import { useEffect } from "react";
import styled from "styled-components";
import AuthPanel from "./AuthPanel";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  display: flex;
  align-items: center;
  justify-content: center;

  animation: fadeIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @keyframes fadeIn {
    from {
      opacity: 0;
      backdrop-filter: blur(0px);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(12px);
    }
  }

  @media (max-width: 768px) {
    align-items: flex-start;
    padding-top: 80px;
    padding-bottom: 30px;
    overflow-y: auto;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  transform: scale(0.95) translateY(10px);
  opacity: 0;
  animation: popIn 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: 0.05s;

  @keyframes popIn {
    to {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;

  width: 40px;
  height: 40px;
  border-radius: 50%;

  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 20px;
  color: #6b7280;
  font-family: sans-serif;
  cursor: pointer;

  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 20;

  &:hover {
    background: #fff;
    color: #eb5e28;
    transform: rotate(90deg) scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.95);
  }
`;

function AuthOverlay({
  signup = false,
  verify = false,
  resetToken = null,
  emailConfirm = false,
  confirmUserId = null,
  confirmToken = null,
  onResetClose = () => {},
  open,
  onClose,
}) {
  useEffect(() => {
    if (!open) return;

    const handEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handEsc);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handEsc);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <Overlay onClick={onClose}>
      <CloseButton onClick={onClose}>✕</CloseButton>
      <Container onClick={(e) => e.stopPropagation()}>
        <AuthPanel
          signup={signup}
          verify={verify}
          resetToken={resetToken}
          emailConfirm={emailConfirm}
          confirmUserId={confirmUserId}
          confirmToken={confirmToken}
          onResetClose={onResetClose}
        />
      </Container>
    </Overlay>
  );
}

export default AuthOverlay;
